import {Box, Paper, Typography, CircularProgress} from '@mui/material';
import useUserCompletedSessions from '../../hooks/quizSession/useUserCompletedSessions';
import formatDate from '../../utils/time/formatDate';

export default function ExerciseActivity() {
  const {sessions, loading, error} = useUserCompletedSessions({limit: 5});
  if (loading) {
    return (
      <Paper sx={{p: 3}}>
        <Typography variant="h5" sx={{fontWeight: 600, mb: 3}}>
          Recent Activity
        </Typography>
        <Box sx={{display: 'flex', justifyContent: 'center', p: 2}}>
          <CircularProgress size={24} />
        </Box>
      </Paper>
    );
  }

  if (error) {
    return (
      <Paper sx={{p: 3}}>
        <Typography variant="h5" sx={{fontWeight: 600, mb: 3}}>
          Recent Activity
        </Typography>
        <Typography color="error">Error loading recent activity</Typography>
      </Paper>
    );
  }

  return (
    <Paper sx={{p: 3}}>
      <Typography variant="h5" sx={{fontWeight: 600, mb: 3}}>
        Recent Activity
      </Typography>
      <Box sx={{display: 'flex', flexDirection: 'column', gap: 2}}>
        {sessions.length === 0 ? (
          <Box sx={{display: 'flex', alignItems: 'center', p: 2, bgcolor: 'grey.50', borderRadius: 1}}>
            <Typography variant="body1" color="text.secondary">
              No recent activity. Start a quiz to see your progress here!
            </Typography>
          </Box>
        ) : (
          sessions.map((session) => (
            <Box
              key={session.id}
              sx={{display: 'flex', alignItems: 'center', p: 2, bgcolor: 'grey.50', borderRadius: 1}}
            >
              <Box sx={{width: 8, height: 8, borderRadius: '50%', bgcolor: 'success.main', mr: 2}} />
              <Box sx={{flex: 1}}>
                <Typography variant="body1">
                  Completed {session.moduleName} quiz - {session.score}% accuracy
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  {formatDate(session.endedAt)}
                </Typography>
              </Box>
            </Box>
          ))
        )}
      </Box>
    </Paper>
  );
}
